import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { BadgeV2 } from "../../../uikit/BadgeV2";

const i18nRoot = "settings.emails.templates";

export const NavigationItem = ({
  label,
  isActive,
  className,
  onClick,
  isComingSoon,
  withDivider,
}: {
  label: string;
  isActive: boolean;
  className?: string;
  onClick?: () => void;
  isComingSoon?: boolean;
  withDivider?: boolean;
}) => (
  <li className={className}>
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "hover:bg-secondary text-default hover:text-selector-active focus:text-selector-active flex w-full items-center justify-between space-y-px rounded-lg px-2 py-1.5 text-sm font-medium leading-5 transition-colors duration-150 ease-linear",
        {
          "bg-tertiary text-selector-active": isActive,
        },
      )}
    >
      {label}
      {isComingSoon && <BadgeV2 label={t([i18nRoot, "coming_soon"])} square />}
    </button>
    {withDivider && <hr className="bg-tertiary border-primary mx-1 my-2" />}
  </li>
);
